export const mainServices = [
  {
    id: "plumbing",
    title: "Plumbing Services",
    description: "Cost-effective plumbing solutions backed by expertise and unparalleled knowledge for residential and commercial properties.",
    icon: "https://i0.wp.com/jerrysplumbingheating.com/wp-content/uploads/2022/04/plumbing-icon.png?resize=150%2C150&ssl=1",
    iconAlt: "hand fixing sink with wrench",
    href: "/plumbing",
    items: [
      "Slab Leak Detection & Repair",
      "Drain & Sewer Cleaning",
      "Water, Sewer & Gas Line Repairs",
      "Water, Sewer & Gas Line Replacements",
      "Water Heater Repairs & Installations",
      "Plumbing Remodels",
      "Garbage Disposal Replacements",
    ],
  },
  {
    id: "welding",
    title: "Welding Services",
    description: "Custom and general welding with professional quality workmanship at competitive prices for any specification.",
    icon: "https://i0.wp.com/jerrysplumbingheating.com/wp-content/uploads/2022/04/welder.png?resize=150%2C150&ssl=1",
    iconAlt: "professional welding service",
    href: "/services",
    items: [
      "Custom Welding",
      "General Welding",
      "Aluminum & Brass Welding",
      "Cast Iron & Copper",
      "Stainless Steel",
      "Structural Steel",
      "Commercial Welding Projects",
    ],
  },
  {
    id: "water-heaters",
    title: "Water Heater Services",
    description: "Get your hot water back fast. High-quality water heater repairs, replacements, and installations at reasonable prices.",
    icon: "https://i0.wp.com/jerrysplumbingheating.com/wp-content/uploads/2022/04/hot-water-heater-icon.png?resize=150%2C150&ssl=1",
    iconAlt: "hot water heater",
    href: "/services",
    items: [
      "Water Heater Repairs",
      "New Water Heater Installation",
      "Tankless Water Heaters",
      "Water Heater Inspection",
      "Emergency Water Heater Service",
    ],
  },
  {
    id: "grease-traps",
    title: "Grease Trap Services",
    description: "Trusted grease trap installation and maintenance — your go-to team for restaurant and commercial kitchen compliance.",
    icon: "https://i0.wp.com/jerrysplumbingheating.com/wp-content/uploads/2022/04/grease-trap-icon.png?resize=150%2C150&ssl=1",
    iconAlt: "grease trap installation",
    href: "/services",
    items: [
      "Grease Trap Installation",
      "Commercial Kitchen Compliance",
      "Grease Trap Maintenance",
      "Sizing & Permitting",
      "Emergency Grease Trap Service",
    ],
  },
];

export const serviceAreas = [
  "Arlington",
  "Bedford",
  "Burleson",
  "Cedar Hill",
  "Colleyville",
  "Coppell",
  "Dallas",
  "Euless",
  "Fort Worth",
  "Grand Prairie",
  "Grapevine",
  "Irving",
  "Keller",
  "Mansfield",
  "North Richland Hills",
  "Southlake",
];

export const faqs = [
  {
    id: 1,
    question: "Who provides plumbing services near me in the DFW area?",
    answer:
      "Jerry's Plumbing, Heating & Welding provides trusted local plumbing services across the Dallas–Fort Worth metroplex. We handle repairs, installations, drain cleaning, and emergency maintenance with same-day response for residential and commercial properties in Cedar Hill, Fort Worth, Dallas, Arlington, and surrounding DFW cities.",
  },
  {
    id: 2,
    question: "How much does plumbing repair cost in Cedar Hill, TX?",
    answer:
      "Plumbing repair costs depend on the issue, materials, and labor involved. Minor repairs like fixture replacements can run $100–$300, while larger jobs like slab leak repairs vary significantly. We provide transparent, upfront quotes with no hidden fees before any work begins.",
  },
  {
    id: 3,
    question: "How long does a plumbing repair take?",
    answer:
      "Most standard plumbing repairs are completed within 1–3 hours. Larger projects like slab leak repairs or full pipe replacements may take 1–3 days depending on scope and parts. We always give you a realistic timeline before starting so you can plan accordingly.",
  },
  {
    id: 4,
    question: "Do you offer emergency plumbing service in DFW?",
    answer:
      "Yes — Jerry's Plumbing offers 24/7 emergency plumbing services across Dallas–Fort Worth, 365 days a year. If you have a burst pipe, gas leak, severe drain backup, or flooding emergency, call us immediately at (817) 832-4968 for a fast response.",
  },
  {
    id: 5,
    question: "Are you licensed and insured to work in Texas?",
    answer:
      "Absolutely. Jerry's Plumbing, Heating & Welding holds Texas Master Plumber License #M12160 and is fully insured. Every job is performed to state code requirements and industry standards by licensed professionals you can trust.",
  },
  {
    id: 6,
    question: "What areas do you serve in the DFW metroplex?",
    answer:
      "We serve Cedar Hill, Fort Worth, Dallas, Arlington, Bedford, Burleson, Colleyville, Coppell, Euless, Grand Prairie, Grapevine, Irving, Keller, Mansfield, North Richland Hills, Southlake, and many more surrounding communities.",
  },
  {
    id: 7,
    question: "Can you handle both residential and commercial plumbing?",
    answer:
      "Yes — we work with both residential homeowners and commercial businesses throughout DFW. From single-family homes to restaurants requiring grease trap installation to commercial buildings needing full plumbing system overhauls, Jerry's has the expertise to handle it all.",
  },
  {
    id: 8,
    question: "What should I do if I have a plumbing emergency right now?",
    answer:
      "First, shut off the main water valve to stop flooding or water damage. Then call Jerry's Plumbing immediately at (817) 832-4968. For gas leaks, evacuate the building and call us plus your gas provider. We'll dispatch a technician to your location as quickly as possible.",
  },
];

export const processSteps = [
  {
    num: "01",
    title: "Call or Request Online",
    description: "Call us at (817) 832-4968 or fill out our quick online form. Describe your issue and we'll schedule a convenient appointment.",
    icon: "ri-phone-line",
  },
  {
    num: "02",
    title: "Expert Diagnosis",
    description: "Our licensed technician arrives promptly, performs a thorough professional diagnosis, and identifies the root cause — not just the symptom.",
    icon: "ri-search-eye-line",
  },
  {
    num: "03",
    title: "Transparent Quote",
    description: "We provide a clear, honest written quote before any work begins. No hidden fees, no surprises — you approve before we start.",
    icon: "ri-file-list-3-line",
  },
  {
    num: "04",
    title: "Quality Repair",
    description: "Our team completes the job efficiently using quality parts, proven techniques, and precision workmanship that meets all Texas code requirements.",
    icon: "ri-tools-line",
  },
  {
    num: "05",
    title: "Verified & Guaranteed",
    description: "We test and verify everything before we leave, walk you through the completed work, and stand behind every repair we make.",
    icon: "ri-checkbox-circle-line",
  },
];

export const whyItems = [
  {
    icon: "ri-medal-line",
    title: "Master Plumber Owned",
    description: "Jerry's is owned and operated by a licensed Texas Master Plumber with over 35 years of hands-on experience across every type of residential and commercial plumbing job.",
  },
  {
    icon: "ri-time-line",
    title: "Reliable & Punctual",
    description: "We respect your time. Our technicians show up when scheduled, work efficiently, and keep you informed every step of the way.",
  },
  {
    icon: "ri-award-line",
    title: "Quality Workmanship",
    description: "Every job is done to code using quality materials. We don't cut corners — we engineer long-term solutions that hold up for years.",
  },
  {
    icon: "ri-heart-line",
    title: "Honest Recommendations",
    description: "No upselling, no fear tactics. We diagnose the real issue and recommend only the work your property actually needs.",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Deep DFW Expertise",
    description: "35+ years in the DFW metroplex means we know local plumbing systems, building codes, soil conditions, and infrastructure inside and out.",
  },
  {
    icon: "ri-alarm-warning-line",
    title: "24/7 Emergency Response",
    description: "Plumbing emergencies don't wait for business hours. We offer round-the-clock emergency services across the entire DFW metroplex, 365 days a year.",
  },
];
